import { DatePicker } from '@progress/kendo-react-dateinputs';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { MultiSelect } from '@progress/kendo-react-dropdowns';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { Checkbox, Input } from '@progress/kendo-react-inputs';
import { useCallback, useEffect, useRef, useState } from 'react';
import { BiComment } from 'react-icons/bi';
import { FaFileExcel, FaUserCircle } from 'react-icons/fa';
import { IoCheckmarkCircleOutline, IoCloseCircleOutline } from 'react-icons/io5';
import { MdClose, MdEdit, MdOutlineAlternateEmail, MdStar } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getCommentHistory, updateRegionAccess, updateUser } from '../../services/dashboard-service/userService';
import HistoryBox from './HistoryBox';




const initialRouteAccess = [
    { id: 1, name: "VehicleVIOReport", title: "Vehicle VIO", checked: false },
    { id: 2, name: "ArticleVIOReport", title: "Article VIO", checked: false },
]


const InputField = ({ icon: Icon, name, value, onChange, placeholder, type = 'text' }) => {
    const [isFocused, setIsFocused] = useState(false);
    return (
        <div className="form-row icon-input">
            {
                Icon === FaFileExcel ?
                    <Icon className="input-icon input-icon-excel" /> :
                    <Icon className="input-icon" />
            }
            <label htmlFor={name} className={`top-left-label ${isFocused ? 'focused' : ''}`} >{placeholder}</label>
            <Input
                name={name}
                type={type}
                disabled={name === "Email" ? true : false}
                value={value || ''}
                onChange={onChange}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                placeholder={''}
            />
        </div>
    );
};




const CustomNameCell = (props) => {
    return (
        <td>
            <div style={{ display: "flex", alignItems: "center" }}>
                <img
                    src={props.dataItem.flag}
                    alt={props.dataItem.name}
                    style={{ width: "20px", height: "15px", marginRight: "8px" }}
                />
                <span>{props.dataItem.name}</span>
            </div>
        </td>
    );
};


const ActionCell = ({ dataItem, userData, fetchUserData }) => {
    const dialogRef = useRef(null)
    const [visible, setVisible] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null)
    const [editDialogVisible, setEditDialogVisible] = useState(false)
    const [toggleHistory, setToggleHistory] = useState(false)
    const [selectedApis, setSelectedApis] = useState([]);
    const [historyData, setHistoryData] = useState([])
    const [routeFields, setRouteFields] = useState(initialRouteAccess)
    const [formErrors, setFormErrors] = useState({})
    const [repeatPassword, setRepeatPassword] = useState('')
    const [selectedFields, setSelectedFields] = useState([])
    const editUserDialogRef = useRef(null)
    const [isFocused, setIsFocused] = useState(false);
    const navigate = useNavigate()
    const [selectedRoute, setSelectedRoute] = useState([])
    const [errors, setErrors] = useState({})
    const [selectAll, setSelecteAll] = useState(false)
    const [originalState, setOriginalState] = useState([])
    const [selectAllColumns, setSelectAllColumns] = useState(true)
    const [formValues, setFormValues] = useState({
        FirstName: "",
        LastName: "",
        Email: "",
        Password: "",
        Company: "",
        OpportunityId: "",
        OpportunityName: "",
        BMEmail: "",
        BMName: "",
        apiCount: "",
        Domain: "",
        startDate: null,
        endDate: null,
        allowedAPIs: [],
        allowedServiceOpt: [],
        allowedChildren: false,
        AllowedExcelExport: null,
        UserEndDate: null,
        vio_StartDate: null,
        vio_EndDate: null,
    });
    const [currentRegion, setCurrentRegion] = useState([
        { id: 1, name: "Denmark", value: "Denmark", flag: 'https://flagcdn.com/w320/dk.png', checked: false },
        { id: 2, name: "Estonia", value: "Estonia", flag: 'https://flagcdn.com/w320/ee.png', checked: false },
        { id: 3, name: "Finland", value: "Finland", flag: 'https://flagcdn.com/w320/fi.png', checked: false },
        { id: 4, name: "France", value: "France", flag: 'https://flagcdn.com/w320/fr.png', checked: false },
        { id: 5, name: "Italy", value: "Italy", flag: 'https://flagcdn.com/w320/it.png', checked: false },
        { id: 6, name: "Norway", value: "Norway", flag: 'https://flagcdn.com/w320/no.png', checked: false },
        { id: 7, name: "Spain", value: "Spain", flag: 'https://flagcdn.com/w320/es.png', checked: false },
        { id: 8, name: "Sweden", value: "Sweden", flag: 'https://flagcdn.com/w320/se.png', checked: false },
        { id: 9, name: "UK", value: "UK", flag: 'https://flagcdn.com/w320/gb.png', checked: false },
    ]);
    const [formUpdateValue, setFormUpdateValue] = useState({
        FirstName: "",
        LastName: "",
        Email: "",
        ApiCount: 0,
        Modified: null,
        StartDate: null,
        EndDate: null,
        UserEndDate: null,
        Id: null,
        AccessFields: null,
        RouteAccess: null,
        PreviousStartDate: null,
        PreviousEndDate: null,
        PreviousApiCount: null,
        Comment: "",
        AllowedExcelExport: null,
        Active: false
    })


    const [fieldsData, setFieldsData] = useState([
        { id: 1, name: "vehicleid", title: "Vehicle ID", checked: true },
        { id: 2, name: "vehiclecount", title: "Vehicle Count", checked: true },
        { id: 3, name: "manufacturerid", title: "Manufacturer ID", checked: true },
        { id: 4, name: "manufacturer", title: "Manufacturer", checked: true },
        { id: 5, name: "modelid", title: "Model ID", checked: true },
        { id: 6, name: "model", title: "Model", checked: true },
        { id: 7, name: "variant", title: "Variant", checked: true },
        { id: 8, name: "enginecode", title: "Engine Code", checked: true },
        { id: 9, name: "fueltype", title: "Fuel Type", checked: true },
        { id: 10, name: "wvtanr", title: "WVTA Number", checked: true },
        { id: 11, name: "power_kw", title: "Power (kW)", checked: true },
        { id: 12, name: "power_ps", title: "Power (PS)", checked: true },
        { id: 13, name: "capacity_ccm", title: "Capacity (CCM)", checked: true },
        { id: 14, name: "noofcyl", title: "No. of Cylinders", checked: true },
        { id: 15, name: "noofvalves", title: "No. of Valves", checked: true },
        { id: 16, name: "bodytype", title: "Body Type", checked: true },
        { id: 17, name: "drivetype", title: "Drive Type", checked: true },
        { id: 18, name: "fromdate", title: "From Date", checked: true },
        { id: 19, name: "todate", title: "To Date", checked: true },
        { id: 20, name: "KBANumber", title: "KBA Number", checked: true },
        { id: 21, name: "Capacity", title: "Capacity", checked: true },
        { id: 22, name: "FuelMixture", title: "Fuel Mixture", checked: true },
        { id: 23, name: "regplate", title: "Regplate", checked: true },
    ]);












    const openDialog = async (userDataCurrent, e) => {
        e.stopPropagation();
        console.log("current user data ->", userDataCurrent)
        await updateDetailsForTheRegion(userDataCurrent)
        setVisible(true)
    }

    const updateDetailsForTheRegion = async (userDataCurrent) => {
        if (!userDataCurrent) return;
        const regionData = await userDataCurrent?.FeatureAllowedModified;
        const updatedRegion = currentRegion.map((region) => {
            console.log("Current region:", region);

            const matchingFeatures = regionData?.find((data) => {
                const isMatch = region.id === data.Id && region.name === data.Feature;
                console.log(`Checking match for region [${region.id}, ${region.name}] with data [${data.Id}, ${data.Feature}]:`, isMatch);
                return isMatch;
            });

            const updated = matchingFeatures
                ? { ...region, checked: true }
                : { ...region, checked: false };

            console.log("Updated region:", updated);
            return updated;
        });
        console.log("final updated region =>",updatedRegion)
        setSelectedUser(userDataCurrent)
        setCurrentRegion(updatedRegion)
        setOriginalState(updatedRegion)
    }

    const formatAccessFieldsString = (fields) => {
        return fields.map(field => `${field.id}::${field.name}`).join(',');
    };


    const parseColumnAccess = (ColumnAccessStr) => {
        if (typeof ColumnAccessStr !== 'string') {
            return [];
        }

        return ColumnAccessStr.split(',').map((item) => {
            const [id, name] = item.split('::')
            return { id: parseInt(id), name }
        })
    }

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (e?.target?.classList.contains('k-overlay')) {
                // Access the Dialog's DOM element using ReactDOM.findDOMNode
                setEditDialogVisible(false)
                setVisible(false)
            }
        }
        if (visible || editDialogVisible) {
            document.addEventListener('click', handleClickOutside)
        }
        else {
            document.removeEventListener('click', handleClickOutside)
        }
        return () => {
            document.removeEventListener('click', handleClickOutside)
        }
    }, [visible, editDialogVisible])
    useEffect(() => {
        const column = formUpdateValue?.AccessFields
        if (formUpdateValue?.AccessFields) {
            const parsedAccessFields = parseColumnAccess(column);
            const updatedFieldsData = fieldsData?.map((field) => ({
                ...field,
                checked: parsedAccessFields?.some(access => access.id === field.id && access.name === field.name)
            }))
            setFieldsData(updatedFieldsData)
            const initalSelectedFields = updatedFieldsData.filter((field) => field.checked)
            setSelectedFields(initalSelectedFields)
            setSelectAllColumns(updatedFieldsData.every((field) => field.checked))
            const allowedFieldOpt = formatAccessFieldsString(initalSelectedFields)
            setFormUpdateValue((prevValue) => ({
                ...prevValue,
                AccessFields: String(allowedFieldOpt)
            }))
        }
    }, [formUpdateValue?.AccessFields])


    const selectAllForColumns = () => {
        setSelectAllColumns((prev) => !prev)
        const newFieldsData = fieldsData.map((item) => ({
            ...item,
            checked: !selectAllColumns
        }))
        setFieldsData(newFieldsData)
        const newItem = newFieldsData.filter((item) => item.checked)
        setSelectedFields(newItem)
        setFormUpdateValue((prevValues) => ({
            ...prevValues,
            AccessFields: formatAccessFieldsString(newItem)
        }));
    }


    const handleCheckboxChangeForRegionFields = (event, dataItem) => {

        const { checked } = event.target?.element;

        setFieldsData((prevData) => {
            const updatedData = prevData.map(item =>
                item.id === dataItem.id ? { ...item, checked } : item
            );
            const allChecked = updatedData.every((item) => item.checked);
            setSelectAllColumns(allChecked); // Update "Select All" immediately
            return updatedData
        });

        const updatedSelectedFields = checked
            ? [...selectedFields, dataItem]
            : selectedFields.filter(field => field.id !== dataItem.id);

        setSelectedFields(updatedSelectedFields);
        setFormUpdateValue((prevValues) => ({
            ...prevValues,
            AccessFields: formatAccessFieldsString(updatedSelectedFields)
        }));
    };

    const handleCheckboxChangeForRouteFields = (event, dataItem) => {

        const { checked } = event.target;

        setSelectedRoute((prevData) => {
            return prevData.map(item =>
                item.id === dataItem.id ? { ...item, checked } : item
            );
        });

        const updatedSelectedFields = checked
            ? [...selectedRoute, dataItem]
            : selectedRoute.filter(field => field.id !== dataItem.id);
        setSelectedRoute(updatedSelectedFields);

        // Update formValues with the new allowedFieldOpt
        if (checked) {
            setFormUpdateValue((prevValues) => ({
                ...prevValues,
                RouteAccess: [...prevValues.RouteAccess, dataItem.name],
            }));
        } else {
            setFormUpdateValue((prevValues) => ({
                ...prevValues,
                RouteAccess: prevValues.RouteAccess.filter(
                    (field) => field !== dataItem.name
                ),
            }));
        }
    };


    const customItemRenderForRoute = (li, itemProps) => {
        const isChecked = selectedRoute.some(api => api.id === itemProps.dataItem.id);
        return (
            <li className="k-item-options">
                <input
                    type="checkbox"
                    style={{ cursor: "pointer", height: "16px", width: "16px", marginRight: "8px" }}
                    checked={isChecked}
                    onChange={(event) => handleCheckboxChangeForRouteFields(event, itemProps.dataItem)}
                />
                <span className="k-checkbox-label">{itemProps.dataItem.title}</span>
            </li>
        );
    };








    const handleUpdateFormChange = useCallback((e) => {
        if (!e?.target) return;

        const { name, value, type, checked } = e.target;
        setFormUpdateValue(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked : type === "number" ? Number(value) : value
        }));
    }, [setFormUpdateValue]);


    const handleUpdateDateChange = useCallback((name, value) => {
        setFormUpdateValue(prev => ({
            ...prev,
            [name]: value
        }));
    }, [setFormUpdateValue]);





    const handleSelectAll = (event) => {
        const isChecked = event.value; // Correctly get the checked state
        const updatedRegions = currentRegion.map(region => ({
            ...region,
            checked: isChecked // Ensure you are updating 'checked'
        }));
        setCurrentRegion(updatedRegions); // Update the state
        setSelecteAll(isChecked); // Update select all state
    };


    const handleCheckboxChange = (event, id) => {

        // const { checked } = event.target.element;
        const { value: checked } = event;
        const updatedRegions = currentRegion.map((region) => region.id === id ? { ...region, checked } : region)
        setCurrentRegion(updatedRegions)
    };
    console.log("Loading the region -> ", currentRegion)
    const CustomCheckboxCell = (props) => {
        return (
            <td>
                <Checkbox
                    defaultChecked={props.dataItem.checked}
                    onChange={(e) => handleCheckboxChange(e, props.dataItem.id)}
                />
            </td>
        );
    };





    const updateFormValues = async (userDataCurrent) => {
        if (!userDataCurrent) return;
        const startDate = userDataCurrent?.vio_StartDate ? new Date(userDataCurrent.vio_StartDate) : null;
        const endDate = userDataCurrent?.vio_EndDate ? new Date(userDataCurrent.vio_EndDate) : null;
        const userEndDate = userDataCurrent?.EndDate ? new Date(userDataCurrent.EndDate) : null;
        const routeAccessName = userDataCurrent?.RouteAccess?.split(',') ?? []
        const updatedRouterFields = routeFields?.filter((field) => routeAccessName.includes(field.name)).map((item) => ({
            ...item,
            checked: true
        }))
        if (userDataCurrent.ColumnAccess === null || userDataCurrent.ColumnAccess === '') {
            setSelectAllColumns(false)
        }
        setSelectedRoute(updatedRouterFields)
        setFormUpdateValue({
            Id: userDataCurrent.Id,
            FirstName: userDataCurrent.FirstName,
            LastName: userDataCurrent.LastName,
            Email: userDataCurrent.Email,
            StartDate: startDate,
            EndDate: endDate,
            RouteAccess: updatedRouterFields.map((item) => item.name) || null,
            AccessFields: userDataCurrent.ColumnAccess,
            AllowedExcelExport: userDataCurrent?.AllowedExcelExport,
            UserEndDate: userEndDate,
            PreviousStartDate: startDate,
            PreviousEndDate: endDate,
            ApiCount: userDataCurrent.ApiCount,
            Comment: userDataCurrent.Comment ?? '',
            Modified: new Date(),
            PreviousApiCount: userDataCurrent.ApiCount,
            Active: userDataCurrent.Active === 1,
        });
    };


    const toggleEditDialog = () => {
        setEditDialogVisible(prev => !prev); // Use functional update
    };

    // useEffect(() => {
    //     if (formUpdateValue.Email) { // Check if form is populated
    //         setEditDialogVisible(true);
    //     }
    // }, [formUpdateValue]);

    const openEditDialog = async (userDataCurrent) => {
        if (!userDataCurrent) return;
        await updateFormValues(userDataCurrent);
        setEditDialogVisible(true); // Open dialog immediately after setting values
    };

    // const handleEditClick = useCallback(() => {
    //     openEditDialog(dataItem);
    // }, [dataItem, openEditDialog]);




    const toggleOpenHistoryDialog = () => {
        setToggleHistory((prev) => !prev)
    }



    const checkHandleState = () => {
        const newChanges = JSON.stringify(originalState) !== JSON.stringify(currentRegion)
        return newChanges
    }




    const handleCancel = () => {
        // Clear the form or handle cancel logic
        setFormValues({
            FirstName: "",
            LastName: "",
            Email: "",
            Password: "",
            Company: "",
            OpportunityId: "",
            OpportunityName: "",
            BMEmail: "",
            BMName: "",
            apiCount: "",
            Domain: "",
            startDate: null,
            endDate: null,
            allowedAPIs: [],
            allowedServiceOpt: [],
            allowedChildren: false,
            endDate: null,
            vio_StartDate: null,
            vio_EndDate: null,
        });
        setRepeatPassword('')
        setSelectedApis([])
        setSelectedUser(null)
    };


    const handleSave = (async () => {
        const changeDetect = checkHandleState();
        if (!changeDetect) {
            toast("No changes detected", {
                type: "warning",
                autoClose: true
            });
            return;
        }
        const AllowedModified = currentRegion.map(({ name, ...rest }) => rest);
        if (userData) {
            const body = {
                userId: selectedUser.APIKeyId,
                AllowedModified
            };
            const updateRegionAccessData = await updateRegionAccess(userData.SecretKey, userData.Token, body);
            if (updateRegionAccessData?.status === 200) {
                toast("Region access updated successfully!", {
                    type: 'success',
                    autoClose: true
                });
                handleCancel();
                fetchUserData();
                setSelectedUser(null);
            }
            else if (updateRegionAccessData?.status === 401 || (updateRegionAccessData?.error && updateRegionAccessData?.error?.statusCode === 401)) {
                setSelectedUser(null);
                localStorage.removeItem("userData")
                navigate('/login')
                toast.error('Session Expired.')
            }
        }
        // setVisible(false)
        setSelecteAll(false);
    });

    const formatDateToCustomString = (isoDateString) => {

        const date = new Date(isoDateString);


        if (isNaN(date.getTime())) {
            return "Invalid date";
        }


        const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
        };


        const formattedDate = date.toLocaleString('en-US', options);


        const [month, day, year] = formattedDate.split('/');
        return `${month}-${day}-${year}`;
    };


    const CustomHeaderCheckboxCell = () => {
        const dataForIndeterminate = currentRegion.some((region) => region.checked) && !currentRegion.every(region => region.checked)
        return (
            <Checkbox

                checked={currentRegion.every(region => region.checked)}
                onChange={handleSelectAll}
            />
        )
    };

    const fetchHistoryData = async (user) => {
        // Add your fetch logic here
        const response = await getCommentHistory(userData?.SecretKey, user?.Id, userData?.Token);
        if (response?.status === 200) {

            const data = response?.data || await response.json();
            const transformedData = Array.isArray(data) ? data.map((item) => ({
                Comment: item.Comment || '',
                Created: formatDateToCustomString(item.Created)
            })) : [];
            setHistoryData(transformedData);
        }
        else if (response?.status === 401 || response?.error?.statusCode === 401) {
            localStorage.removeItem("userData")
            navigate('/login')
            toast.error('Session Expired.')
        }
        else {
            setHistoryData([])
        }
    }

    const openHistoryBox = (currentUser) => {
        fetchHistoryData(currentUser)
        toggleOpenHistoryDialog();
    }



    const handelCancelEditUser = () => {
        setFormUpdateValue({
            FirstName: "",
            LastName: "",
            Email: "",
            ApiCount: 0,
            Modified: null,
            StartDate: null,
            EndDate: null,
            Id: null,
            AllowedExcelExport: null,
            UserEndDate: null,
            PreviousEndDate: null,
            PreviousApiCount: null,
            Comment: "",
            Active: false
        });
        setEditDialogVisible(false);
    }

    const validateForm = () => {
        const errors = {};
        if (!formUpdateValue.FirstName.trim()) {
            errors.FirstName = "First Name is required";
        }

        if (!formUpdateValue.LastName.trim()) {
            errors.LastName = "Last Name is required";
        }

        if (!formUpdateValue.StartDate) {
            errors.StartDate = "Start Date is required";
        }

        if (!formUpdateValue.EndDate) {
            errors.EndDate = "End Date is required";
        }
        else if (formUpdateValue.EndDate < formUpdateValue.StartDate) {
            errors.EndDate = "VIO End Date must be greater than or equal to VIO Start Date";
        }

        if (!formUpdateValue.UserEndDate) {
            errors.UserEndDate = "User End Date is required";
        }
        else if (formUpdateValue.UserEndDate < new Date()) {
            errors.UserEndDate = "User End Date should be greater than Start Date";
        }


        setFormErrors(errors);
        return errors;
    };

    const handleEditSave = async () => {
        const validData = validateForm()
        const isValid = Object.keys(validData).length === 0
        if (!isValid) {
            // If there are errors, show the first error message
            const firstErrorKey = Object.keys(validData)[0];
            toast(formErrors[firstErrorKey], {
                type: 'error',
                autoClose: true
            });
            return; // Exit early if the form is not valid
        }
        else if (!formUpdateValue?.AccessFields?.length > 0) {
            toast("Please select at least one field", {
                type: 'error',
                autoClose: true
            });
            return; //exit early if the form is valid
        }
        else if (!formUpdateValue?.RouteAccess.length > 0) {
            toast('Please select at least one feature', {
                type: 'error',
                autoClose: true
            })
            return;
        }
        else if (userData) {
            const updateRegionAccessData = await updateUser(userData.SecretKey, formUpdateValue, userData.Token);
            if (updateRegionAccessData?.status === 200) {
                toast("User Updated Successfully!", {
                    type: 'success',
                    autoClose: true
                });
                handelCancelEditUser()
                setSelectedUser(null)
                toggleEditDialog()
                fetchUserData()

            }
            else if (updateRegionAccessData?.status === 401 || updateDetailsForTheRegion?.error?.statusCode === 401) {
                localStorage.removeItem("userData")
                navigate('/login')
                toast.error('Session Expired.')
            }
            else {
                toast("Try Again Later.", {
                    type: 'error',
                    autoClose: true
                })
            }
        }
    };



    const memoizedHandleSave = useCallback(() => {
        handleEditSave();
    }, [handleEditSave]);

    const handleMultiSelectChangeRoute = (event) => {
        const newSelectedApi = event.target.value;
        // Handle error message if no route access is selected


        if (newSelectedApi.length === 0) {
            setFormErrors((prevErrors) => ({
                ...prevErrors,
                selectedRoutes: "Please select at least one Feature."
            }));
        }
        else {
            setFormErrors((prevErrors) => ({
                ...prevErrors,
                selectedRoutes: null,
            }));
        }
        // Update the selected APIs
        setSelectedRoute(newSelectedApi);

        // Update allowedServiceOpt based on selected APIs
        const detectedRegions = selectedRoute.filter(api =>
            !newSelectedApi.some(newApi => newApi.id === api.id)
        );
        if (detectedRegions.length > 0) {
            let updatedAllowedServiceOpt = [...formUpdateValue.RouteAccess];
            if (updatedAllowedServiceOpt.length > 0) {
                detectedRegions.forEach(api => {
                    updatedAllowedServiceOpt = updatedAllowedServiceOpt.filter(feature => feature !== api.name);
                });
            }
            setFormUpdateValue((prevValues) => ({
                ...prevValues,
                RouteAccess: updatedAllowedServiceOpt
            }));
        }
    };


    return (
        <>
            <td>
                <MdStar
                    style={{ color: '#1976d2', marginRight: '10px', cursor: 'pointer' }}
                    title="Feature List"
                    fontSize="1.4rem"
                    height="1em"
                    width="1em"
                    onClick={(e) =>
                        openDialog(dataItem, e)
                    }

                />
                <MdEdit
                    style={{ color: '#1976d2', cursor: 'pointer' }}
                    title="Edit User Details"
                    fontSize="1.4rem"
                    height="1em"
                    width="1em"
                    onClick={() => openEditDialog(dataItem)}
                />
            </td>
            {visible && (
                <Dialog >
                    <div className='dialog-api-main-second'>
                        <button className="close-icon" onClick={() => setVisible(false)}>
                            <MdClose size={22} />
                        </button>
                        <div className='dialog-api-header'>
                            <h2>Region Access</h2>
                        </div>
                        <div className='dialog-api-table'>
                            <Grid
                                data={currentRegion}
                                style={{ height: '400px' }}
                            >
                                {/* Checkbox column */}
                                <GridColumn
                                    field="checked"
                                    width="50px"
                                    headerCell={CustomHeaderCheckboxCell}
                                    cell={CustomCheckboxCell}
                                />
                                {/* API Name column */}
                                <GridColumn field="name" title="Select VIO Region" cell={CustomNameCell} />
                            </Grid>
                        </div>
                        <DialogActionsBar>
                            <div className='custom-button-dialog'>
                                <button
                                    className="k-button k-button-md k-rounded-md k-button-solid"
                                    style={{ backgroundColor: '#94ce97', color: 'white' }}
                                    onClick={handleSave}
                                >
                                    Save
                                    <IoCheckmarkCircleOutline className='icons-region' />
                                </button>
                                <button
                                    className="k-button k-button-md k-rounded-md k-button-solid"
                                    style={{ backgroundColor: '#ef6e6e', color: 'white' }}
                                    onClick={() => setVisible(false)}
                                >
                                    Cancel
                                    <IoCloseCircleOutline className='icons-region' />
                                </button>
                            </div>
                        </DialogActionsBar>
                    </div>
                </Dialog >
            )}
            {
                editDialogVisible && formUpdateValue?.Email.length > 0 && (
                    <Dialog onClose={toggleEditDialog} className="edit-user-dialog">
                        <div ref={editUserDialogRef} className="dialog-edit-main">
                            <button className="close-icon-edit" onClick={toggleEditDialog}>
                                <MdClose size={22} />
                            </button>
                            <div className="dialog-edit-content">
                                <div className="edit-user-header">
                                    <h2>Edit User</h2>
                                </div>
                                <div className="dialog-user-content">
                                    <div className="dialog-padding-content" style={{ maxHeight: "500px", overflow: "auto" }}>
                                        <InputField
                                            icon={FaUserCircle}
                                            name="FirstName"
                                            value={formUpdateValue?.FirstName}
                                            onChange={handleUpdateFormChange}
                                            placeholder="First Name*"
                                        />
                                        <InputField
                                            icon={FaUserCircle}
                                            name="LastName"
                                            value={formUpdateValue?.LastName}
                                            onChange={handleUpdateFormChange}
                                            placeholder="Last Name*"
                                        />
                                        <InputField
                                            icon={MdOutlineAlternateEmail}
                                            name="Email"
                                            value={formUpdateValue?.Email}
                                            onChange={handleUpdateFormChange}
                                            placeholder="Email Address*"
                                        />
                                        <InputField
                                            icon={BiComment}
                                            name="Comment"
                                            value={formUpdateValue?.Comment}
                                            onChange={handleUpdateFormChange}
                                            placeholder="Comment"
                                        />
                                        <div className="form-row-date">
                                            <label htmlFor='featureAccess' className={`top-left-label ${isFocused ? 'focused' : ''}`} >Feature Access*</label>
                                            <MultiSelect
                                                className='multi-select'
                                                autoClose={false}
                                                data={routeFields}
                                                value={selectedRoute}
                                                onChange={handleMultiSelectChangeRoute}
                                                textField="title"
                                                dataItemKey="id"
                                                itemRender={customItemRenderForRoute}
                                            />
                                        </div>
                                        <InputField
                                            icon={FaFileExcel}
                                            name="AllowedExcelExport"
                                            type="number"
                                            value={formUpdateValue?.AllowedExcelExport}
                                            onChange={handleUpdateFormChange}
                                            placeholder="Excel Count" />
                                        <div className="multi-select-main-form form-row-multiselect">
                                            <div className='checkbox-list' style={{ marginBottom: "1rem" }}>
                                                <div className="checkbox-item">
                                                    <Checkbox
                                                        name="selectall"
                                                        label={selectAllColumns ? "Deselect All" : "Select All"}
                                                        title="Select All"
                                                        checked={selectAllColumns}
                                                        onChange={selectAllForColumns} />
                                                </div>
                                            </div>
                                            <div className="checkbox-list">
                                                {fieldsData.map((field) => (
                                                    <div key={field.id} className="checkbox-item">
                                                        <Checkbox
                                                            name={field.id.toString()}
                                                            label={field.title}
                                                            checked={selectedFields.some(selected => selected.id === field.id)}
                                                            onChange={(e) => handleCheckboxChangeForRegionFields(e, field)}
                                                        />
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                        <div className="form-row-date">
                                            <label htmlFor='UserEndDate' className={`top-left-label ${isFocused ? 'focused' : ''}`} >End Date*</label>
                                            <DatePicker
                                                name="UserEndDate"
                                                value={formUpdateValue.UserEndDate}
                                                onChange={(e) => handleUpdateDateChange('UserEndDate', e.value)}
                                                placeholder=""
                                                onFocus={() => setIsFocused(true)}
                                                onBlur={() => setIsFocused(false)}
                                            />
                                        </div>

                                        <div className="form-row-date">
                                            <label htmlFor='vio_StartDate' className={`top-left-label ${isFocused ? 'focused' : ''}`} >VIO Start Date*</label>
                                            <DatePicker
                                                name="startDate"
                                                value={formUpdateValue.StartDate}
                                                onChange={(e) => handleUpdateDateChange('StartDate', e.value)}
                                                placeholder=""
                                                onFocus={() => setIsFocused(true)}
                                                onBlur={() => setIsFocused(false)}
                                            />
                                        </div>

                                        <div className="form-row-date">
                                            <label htmlFor='vio_EndDate' className={`top-left-label ${isFocused ? 'focused' : ''}`} >VIO End Date*</label>
                                            <DatePicker
                                                name="EndDate"
                                                value={formUpdateValue.EndDate}
                                                onChange={(e) => handleUpdateDateChange('EndDate', e.value)}
                                                placeholder=""
                                                onFocus={() => setIsFocused(true)}
                                                onBlur={() => setIsFocused(false)}
                                            />
                                        </div>
                                        <div className="form-row-child">
                                            <Checkbox
                                                name="Active"
                                                checked={formUpdateValue.Active || false}
                                                onChange={handleUpdateFormChange}
                                                label="Is Active"
                                            />
                                            <button
                                                className="k-button k-button-md k-rounded-md k-button-solid"
                                                style={{ backgroundColor: 'rgb(88, 156, 222)', color: 'white' }}
                                                onClick={() => openHistoryBox(dataItem)}
                                            >
                                                History
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <DialogActionsBar>
                                    <div className="custom-button-dialog">
                                        <button
                                            className="k-button k-button-md k-rounded-md k-button-solid"
                                            style={{ backgroundColor: '#94ce97', color: 'white' }}
                                            onClick={memoizedHandleSave}
                                        >
                                            Save
                                            <IoCheckmarkCircleOutline className="icons-region" />
                                        </button>
                                        <button
                                            className="k-button k-button-md k-rounded-md k-button-solid"
                                            style={{ backgroundColor: '#ef6e6e', color: 'white' }}
                                            onClick={toggleEditDialog}
                                        >
                                            Cancel
                                            <IoCloseCircleOutline className="icons-region" />
                                        </button>
                                    </div>
                                </DialogActionsBar>
                            </div>
                        </div>
                    </Dialog>
                )
            }
            {
                toggleHistory && (
                    <HistoryBox setToggleHistory={setToggleHistory} dialogRef={dialogRef} historyData={historyData} />

                )
            }
        </>
    );
};

export default ActionCell